const VITE_APP_ENV = import.meta.env.VITE_APP_ENV || "dev";
const VITE_APP_LOCAL_PORT = import.meta.env.VITE_APP_LOCAL_PORT || "8011";

const API_BASE_URLS: Record<string, string> = {
  local: `http://127.0.0.1:${VITE_APP_LOCAL_PORT}`,
  dev: "https://data-api-dev.sovfixer.com",
  stg: "https://data-api-staging.sovfixer.com",
  prd: "https://data-api.sovfixer.com",
};

export const API_BASE_URL = API_BASE_URLS[VITE_APP_ENV] || API_BASE_URLS.dev;
